import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import MediaSelector, { MediaSelectorMode } from "../media/mediaSelector.comp";

export default function MaterialMediaEditor({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();
  return (
    <>
      {/* <EditorSection>
        <Title>{t(msg.product.extUrl)}</Title>
        <LabelAndInput register={methods.register} fieldName="extUrl" label={t(msg.product.extUrl)} topLabelCss="block text-xs" />
      </EditorSection> */}

      <div className="text-xs flex flex-col">
        <div className="basis-1/3">
          <MediaSelector
            id="feature-image"
            mode={MediaSelectorMode.single}
            label={t(msg.product.featuredImage)}
            defaultSelectedIds={methods.getValues("featuredMediaId") === undefined ? [] : [methods.getValues("featuredMediaId")]}
            className="mh-10 my-2"
            onChanged={(ids) => {
              if (ids === undefined || ids.length === 0) {
                methods.setValue("featuredMediaId", undefined);
              } else {
                methods.setValue("featuredMediaId", ids[0]);
              }
            }}
          />
        </div>

        <div className="basis-1/3">
          <MediaSelector
            id="product-gallery"
            mode={MediaSelectorMode.multiple}
            label={t(msg.product.productGallery)}
            defaultSelectedIds={methods.getValues("galleryIds")}
            className="mh-10 my-2"
            onChanged={(ids) => {
              methods.setValue("galleryIds", ids);
            }}
          />
        </div>
      </div>
    </>
  );
}
